import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { type SkeletonConfig } from './skeleton.types';

const RADIUS_MAP: Record<string, string> = {
  sm: 'rounded-sm',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
  full: 'rounded-full',
};

@Component({
  selector: 'app-skeleton',
  template: `<div
    [class]="classes()"
    [style]="styles()"
  ></div>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Skeleton {
  readonly config = input.required<SkeletonConfig>();

  protected readonly classes = computed(() => {
    const radius = this.config().borderRadius ?? 'xl';
    return `bg-(--p-surface-200) animate-pulse ${RADIUS_MAP[radius] ?? 'rounded-xl'}`;
  });

  protected readonly styles = computed(() => {
    const { height, width } = this.config();
    return {
      height: height ?? '42px',
      width: width ?? '100%',
    };
  });
}
